
import "../App.css";
import hero_img3 from "../assets/images/hero-image3.png";
import hero_img2 from "../assets/images/hero-image2.png";
import hero_img1 from "../assets/images/hero-image1.png";
import paper_img from "../assets/images/paper_img.jpg";
import cartoon_img from "../assets/images/cartoon_img.png";

// خدماتنا
export default function ServicesPreview() {

    const services = [
  {
    id: 1,
    title: "إعادة تدوير الورق",
    description:
      "حلول متخصصة لجمع وفرز وإعادة تدوير المخلفات الورقية بطريقة فعالة ومستدامة.",
    image: paper_img,
  },
  {
    id: 2,
    title: "إعادة تدوير الكرتون",
    description:
      "إدارة ومعالجة مخلفات الكرتون وتحويلها إلى مواد قابلة لإعادة الاستخدام.",
    image: cartoon_img,
  },
  {
    id: 3,
    title: "الجمع والفرز",
    description:
      "خدمات متكاملة لجمع المواد القابلة لإعادة التدوير وفرزها وتجهيزها.",
    image: hero_img1,
  },
];

    return (
        <>
       {/* <!-- خدماتنا --> */}
     <section className="bg-white py-20" dir="rtl">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">

        {/* Section Header */}
        <div className="mx-auto mb-14 max-w-2xl text-center">

          <span className="mb-3 block text-sm font-semibold text-green-600">
            خدماتنا
          </span>

          <h2 className="text-3xl font-bold text-gray-900 md:text-4xl">
            حلول متكاملة في إعادة التدوير
          </h2>

          <p className="mt-4 leading-8 text-gray-600">
            نقدم مجموعة من الحلول والخدمات التي تساعد الشركات والمنشآت
            على إدارة المواد القابلة لإعادة التدوير بكفاءة.
          </p>

        </div>

        {/* Services */}
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3">

          {services.map((service) => (
            <article
              key={service.id}
              className="group overflow-hidden rounded-2xl border border-gray-100 bg-white shadow-sm transition-all duration-300 hover:-translate-y-2 hover:shadow-xl"
            >

              {/* Image */}
              <div className="relative h-64 overflow-hidden">

                <img
                  src={service.image}
                  alt={service.title}
                  className="h-full w-full object-cover transition duration-500 group-hover:scale-110"
                />

                {/* Overlay */}
                <div className="absolute inset-0 bg-black/10 transition duration-300 group-hover:bg-black/25" />

              </div>

              {/* Content */}
              <div className="p-7">

                <h3 className="mb-3 text-xl font-bold text-gray-900">
                  {service.title}
                </h3>

                <p className="mb-6 leading-7 text-gray-600">
                  {service.description}
                </p>

                <button
                  type="button"
                  className="inline-flex items-center gap-2 font-semibold text-green-600 transition hover:text-green-700"
                >
                  اعرف المزيد
                  <span className="transition-transform duration-300 group-hover:-translate-x-1">
                    ←
                  </span>
                </button>

              </div>

            </article>
          ))}

        </div>

        {/* All Services Button */}
        <div className="mt-12 text-center">

          <a
            href="/services"
            className="inline-flex rounded-lg border-2 border-green-600 px-8 py-3 font-semibold text-green-600 transition duration-300 hover:bg-green-600 hover:text-white"
          >
            عرض جميع الخدمات
          </a>

        </div>

      </div>
    </section>
        </>
    );
}   